// extracted by mini-css-extract-plugin
export default {"container":"UnicoMultiFactorAuthentication__container--27X"};